import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../SellerRelatedProducts/SellerRelatedProducts.css";
import { MdBrokenImage } from "react-icons/md";
import placeholder from "../../assets/placeholder.jpg"

function ProductImage({ src, alt }) {
  const [imgSrc, setImgSrc] = useState(src || placeholder);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className="related-img pt-4 m-auto"
      onError={() => setImgSrc(placeholder)}
    />
  );
}


export default function SellerRelatedProducts({ products = [] }) {
  const location = useLocation();

  const isFullPage =
    location.pathname.includes("sellerrelatedproducts");

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div className="sellerrelated-section m-auto pb-5 pt-4">

      {/* ===== Header ===== */}
      <div className="related-header">
        <h3 className="related-title">ذات صلة</h3>

        {!isFullPage && (
          <Link
            to="/seller/sellerrelatedproductswrapper"
            className="related-view-btn"
          >
            رؤية المزيد
          </Link>
        )}
      </div>

      {/* ===== Cards ===== */}
      <div className="related-cards">
        {products.map((item) => {
            console.log("PRODUCT:", item);
          const finalPrice =
            item.priceAfterDiscount && item.priceAfterDiscount > 0
              ? item.priceAfterDiscount
              : item.price;

          return (
            <Link
              to={`/seller/sellerproductdetails/${item.id}`}
              className="related-card px-3"
              key={item.id}
            >
              <ProductImage
                // src={item.images?.[0]}
                //                 src={
                //   Array.isArray(item.image)
                //     ? item.image[0]?.url 
                //     : item.image 
                // }
                // src={item.image?.url || placeholder}
                // alt={item.name}
                src={
  Array.isArray(item.image)
    ? item.image[0]?.url || placeholder
    : item.image?.url || placeholder
}
              />

              <h4 className="related-name">{item.name}</h4>

              <p className="desc">{item.description}</p>

              <p className="price">
                {finalPrice} {item.currencyType}
              </p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
